import React from 'react';

export default function ShippingPolicy() {
  return (
    <div className="container mx-auto px-4 py-12">
      <h1 className="text-3xl font-bold mb-8">Shipping Policy</h1>
      <div className="prose max-w-none">
        <p className="mb-4">Last updated: {new Date().toLocaleDateString()}</p>
        
        <h2 className="text-2xl font-semibold mt-8 mb-4">1. Shipping Rates</h2>
        <div className="mb-6">
          <ul className="list-disc pl-6 mb-4">
            <li>Flat rate shipping of $10 for all orders under $100</li>
            <li>FREE shipping on all orders over $100</li>
            <li>Currently shipping to continental United States only</li>
          </ul>
        </div>

        <h2 className="text-2xl font-semibold mt-8 mb-4">2. Order Processing</h2>
        <p>Orders are processed within 24-48 hours of receipt. Processing times may be longer during peak seasons or promotions.</p>

        <h2 className="text-2xl font-semibold mt-8 mb-4">3. Delivery Time</h2>
        <p>Standard delivery time is 5-7 business days from the date of shipment. Please note that delivery times may vary based on your location within the continental United States.</p>

        <h2 className="text-2xl font-semibold mt-8 mb-4">4. Tracking Information</h2>
        <p>Tracking information will be provided via email once your order ships. You can track your order using the tracking number provided in the shipping confirmation email.</p>

        <h2 className="text-2xl font-semibold mt-8 mb-4">5. Shipping Restrictions</h2>
        <p>Due to regulations regarding fuel additives:</p>
        <ul className="list-disc pl-6 mb-4">
          <li>We currently only ship within the continental United States</li>
          <li>We cannot ship to P.O. boxes</li>
          <li>Some areas may have additional restrictions on fuel additives</li>
        </ul>

        <h2 className="text-2xl font-semibold mt-8 mb-4">6. Contact Information</h2>
        <p>For shipping-related inquiries, please contact us through:</p>
        <ul className="list-disc pl-6 mb-4">
          <li>Email: support@marinefuelboost.com</li>
          <li>Phone: (970) 438-2963</li>
        </ul>

        <div className="bg-blue-50 p-4 rounded-lg mt-8">
          <h3 className="text-xl font-semibold mb-2">Important Note</h3>
          <p>We strive to deliver your order as quickly as possible. If you have any questions about your shipment or our shipping policy, please don't hesitate to contact us.</p>
        </div>
      </div>
    </div>
  );
} 